export default __webpack_public_path__ + "static/it_hero-826e9800ae8972853922225e4e8b21ee.jpg";